module.exports = __webpack_public_path__ + "static/media/unlock.e74794e2.svg";